import { render, staticRenderFns } from "./Apartment.vue?vue&type=template&id=5ed89f18&scoped=true&"
import script from "./Apartment.vue?vue&type=script&lang=js&"
export * from "./Apartment.vue?vue&type=script&lang=js&"
import style0 from "./Apartment.vue?vue&type=style&index=0&id=5ed89f18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed89f18",
  null
  
)

export default component.exports